import { render, staticRenderFns } from "./change-payment-methods.vue?vue&type=template&id=5c87ed2a&scoped=true&"
import script from "./change-payment-methods.vue?vue&type=script&lang=js&"
export * from "./change-payment-methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c87ed2a",
  null
  
)

export default component.exports